import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-50 text-center">
      <h1 className="text-4xl font-bold text-slate-800">404</h1>
      <p className="text-sm text-slate-500">Página não encontrada.</p>
      <Link to="/" className="text-sm font-medium text-sky-600 hover:underline">
        Voltar ao início
      </Link>
    </div>
  );
}
